export default "__VITE_ASSET__Dxo7caIk__"